import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const LinkIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 21",
    fill: "currentColor",
    width: size || '1em',
    height: size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "currentColor",
    d: "M3.7,8l2.6,2.3c0.4,0.4,0.4,1,0.1,1.4c0,0,0,0-0.1,0.1l-0.6,0.6c-0.4,0.4-1,0.4-1.4,0L1.8,9.9 C0.6,8.8,0,7.3,0,5.8c0-1.5,0.6-3,1.8-4.1C2.9,0.6,4.4,0,6,0c1.6,0,3.1,0.6,4.2,1.7l2.6,2.4l0,0c0.4,0.4,0.4,1,0,1.4l-0.6,0.6 c-0.4,0.4-1,0.4-1.4,0L8.2,3.7C7.6,3.1,6.8,2.8,6,2.8c-0.9,0-1.6,0.3-2.2,0.9C3.1,4.3,2.8,5,2.8,5.8S3.1,7.4,3.7,8L3.7,8z M18.3,13 l-2.6-2.3c-0.4-0.4-0.4-1-0.1-1.4c0,0,0,0,0.1-0.1l0.6-0.6c0.4-0.4,1-0.4,1.4,0l2.7,2.5c1.1,1.1,1.8,2.5,1.8,4.1 c0,1.5-0.6,3-1.8,4.1C19.1,20.4,17.6,21,16,21c-1.6,0-3.1-0.6-4.2-1.7l-2.6-2.4c-0.4-0.4-0.4-1-0.1-1.4c0,0,0,0,0,0l0.6-0.6 c0.4-0.4,1-0.4,1.4,0l2.7,2.5c0.6,0.6,1.4,0.9,2.2,0.9c0.9,0,1.6-0.3,2.2-0.9c0.6-0.6,0.9-1.3,0.9-2.2S18.9,13.6,18.3,13L18.3,13z M6.9,7.1l0.7-0.7C8,6,8.6,6,9,6.4c0,0,0,0,0,0l6,6c0.4,0.4,0.4,1,0,1.4l-0.7,0.7c-0.4,0.4-1,0.4-1.4,0l-6-6 C6.5,8.1,6.5,7.5,6.9,7.1z"
  }));
};
LinkIcon.displayName = 'LinkIcon';
export default LinkIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LinkIcon.js.map